/* SessionAgent.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlN91d%7Bmax-width%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAYvD1%7Boverflow-x%3Avisible%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGYvD1%7Boverflow-y%3Avisible%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02xpxF%7Bwidth%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0VxpxF%7Bheight%3A9pt%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02ey7F%7Bwidth%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0jFU0Vey7F%7Bheight%3A1pc%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcaTCRo%7Btransform%3Ascale(.75)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0yKXXaDIqT%7Btransform-origin%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPca7KdW%7Btransform%3Atranslate(2px%2C1px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPca8SLj%7Btransform%3Ascale(.5)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcaDWNG%7Btransform%3Ascale(.666667)%7D");
import React from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@atlaskit/css';
import { RovoIcon } from '@atlaskit/logo';
import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';
import { Box, Flex, Inline, Text } from '@atlaskit/primitives/compiled';
import { messages } from './messages';
const styles = {
  agents: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1EqgXlN91d",
  agent: "_4ouGXIdnbC",
  agentName: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _39HuIbz8Lp _1ANEUSLRg7",
  defaultAgents: "_4bt5LAYvD1 _2WAcuGYvD1",
  iconOnlyAgents: "_4bt5LAYvD1 _2WAcuGYvD1"
};
const agentIconSizeStyles = {
  12: "_4bt5LAnQyn _2WAcuGnQyn _39xV02xpxF _0jFU0VxpxF _3YEZNOdnbC",
  16: "_4bt5LAnQyn _2WAcuGnQyn _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC"
};
const rovoAgentIconSizeStyles = {
  12: "_4bt5LAnQyn _2WAcuGnQyn _39xV02xpxF _0jFU0VxpxF _3YEZNOdnbC",
  16: "_4bt5LAYvD1 _2WAcuGYvD1 _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC"
};
const agentAvatarSizeStyles = {
  12: "_1VJPca8SLj",
  16: "_1VJPcaDWNG"
};
const rovoIconSizeStyles = {
  12: "_1VJPcaTCRo _0yKXXaDIqT",
  16: "_1VJPca7KdW _0yKXXaDIqT"
};
export type SessionIconSize = 12 | 16;
export type SessionAgentDetails = {
  id: string;
  name: string;
  avatarUrl?: string;
  agentId?: string;
  agentIdentityAccountId?: string;
  agentNamedId?: string;
};
export type SessionAgentProps = {
  agents: ReadonlyArray<SessionAgentDetails>;
  /** Whether to render visible agent names alongside their avatars. */
  showNames?: boolean;
  /** Whether to render the standard Rovo icon instead of an agent avatar. */
  isDefaultAgent?: boolean;
  /** Visual size for agent icons. Defaults to 12. */
  iconSize?: SessionIconSize;
  additionalAgentCount?: number;
  testId?: string;
};

/** Renders the agents participating in a session and an optional overflow count. */
export const SessionAgent = ({
  agents,
  showNames = true,
  isDefaultAgent = false,
  iconSize = 12,
  additionalAgentCount,
  testId
}: SessionAgentProps): React.JSX.Element | null => {
  const {
    formatMessage
  } = useIntl();
  if (agents.length === 0 && !additionalAgentCount) {
    return null;
  }
  return <Inline xcss={cx(styles.agents, isDefaultAgent && showNames && styles.defaultAgents, !showNames && styles.iconOnlyAgents)} alignBlock="center" space="space.100" testId={testId}>
			{agents.map(agent => {
      const agentName = agent.name;
      return <Inline as="span" xcss={styles.agent} alignBlock="center" space="space.100" key={agent.id}>
						{isDefaultAgent ? <Flex as="span" xcss={rovoAgentIconSizeStyles[iconSize]} alignItems="center" justifyContent="center">
								<Box as="span" xcss={rovoIconSizeStyles[iconSize]}>
									<RovoIcon label={agentName} size="xxsmall" />
								</Box>
							</Flex> : <Flex as="span" xcss={agentIconSizeStyles[iconSize]} alignItems="center" justifyContent="center">
								<Box as="span" xcss={agentAvatarSizeStyles[iconSize]}>
									<AgentAvatar size="small" imageUrl={agent.avatarUrl} name={agent.name} label={agent.name} agentId={agent.agentId} agentIdentityAccountId={agent.agentIdentityAccountId} agentNamedId={agent.agentNamedId} />
								</Box>
							</Flex>}
						{showNames ? <Box as="span" xcss={styles.agentName}>
								{agentName}
							</Box> : null}
					</Inline>;
    })}
			{additionalAgentCount && additionalAgentCount > 0 ? <Box as="span" role="img" aria-label={formatMessage(messages.additionalAgentsLabel, {
      count: additionalAgentCount
    })}>
					<Text as="span" weight="medium">
						{formatMessage(messages.additionalAgents, {
          count: additionalAgentCount
        })}
					</Text>
				</Box> : null}
		</Inline>;
};